// Canonical announcement tag list. Imported by AdminDashboard (which
// publishes) and HRPortal (which displays). Labels MUST exactly match
// the DB CHECK constraint on announcements.tag (db/schema.sql) — adding
// or renaming a tag means a schema migration too.

export const ANN_TAGS = [
  { label: 'Reviews', color: '#7B5CC8' },
  { label: 'Policy', color: '#C9A84C' },
  { label: 'General', color: '#1D9E75' },
  { label: 'Benefits', color: '#5DCAA5' },
  { label: 'Learning & Development', color: '#7F77DD' },
];

export const ANN_TAG_NAMES = ANN_TAGS.map(t => t.label);

export const annTagColor = t => ANN_TAGS.find(x => x.label === t)?.color || '#8888aa';
